import commonActions from '../common/actions';
import accountActions from '../modules/account/actions';
import agentActions from '../modules/agents/actions';
import planActions from '../modules/plans/actions';
import orderActions from '../modules/orders/actions';
import notificationActions from '../modules/notification/action';

const actionTypes = Object.assign({},
  commonActions.actionTypes,
  accountActions.actionTypes,
  agentActions.actionTypes,
  planActions.actionTypes,
  orderActions.actionTypes,
  notificationActions.actionTypes,
);

export { actionTypes };

export default Object.assign({},
  commonActions.actions,
  accountActions.actions,
  agentActions.actions,
  planActions.actions,
  orderActions.actions,
  notificationActions.actions,
);
